import { REQUISICAO_ADMIN, REQUISICAO_ADMIN_DRONE } from '../../../constants/modules';
import { hasModuleConfiguration } from '../../../helpers/moduleConfigurationPermission';

const permOptions = { allowNullUserId: true };

export const hasRequisicaoAdmin = (moduleConfigurations, authData) =>
  hasModuleConfiguration(moduleConfigurations, authData, REQUISICAO_ADMIN, permOptions);

export const hasRequisicaoAdminDrone = (moduleConfigurations, authData) =>
  hasModuleConfiguration(moduleConfigurations, authData, REQUISICAO_ADMIN_DRONE, permOptions);

export const isRequisicaoAdmin = (moduleConfigurations, authData) =>
  hasRequisicaoAdmin(moduleConfigurations, authData)
  || hasRequisicaoAdminDrone(moduleConfigurations, authData);

export const canOperarAreaRequisicao = (moduleConfigurations, authData, area) => {
  if (area === 'DRONE') return hasRequisicaoAdminDrone(moduleConfigurations, authData);
  if (area === 'ALMOXARIFADO') return hasRequisicaoAdmin(moduleConfigurations, authData);
  return hasRequisicaoAdmin(moduleConfigurations, authData);
};
